
import axios from 'axios'
import localforage from 'localforage'
import router from '@/router'
import store from '@/store'
import { bus } from '@/plugins/event-bus'

const http = axios.create({
  baseURL: process.env.API_URL
})

const setLoading = (state) => {
  store.dispatch('setLoading', { loading: state })
}

const interceptRequest = async (config) => {
  setLoading(true)
  const token = await localforage.getItem('token')
  config.headers.common['Authorization'] = token
  return config
}
const interceptRequestError = (error) => {
  setLoading(false)
  Promise.reject(error)
}

const interceptResponse = (response) => {
  setLoading(false)
  return response
}

const interceptResponseError = (error) => {
  let message = error.message

  if (error.response != null) {
    if (error.response.status === 401) {
      router.push({ name: 'dashboard', query: { forbidden: true } })
    }
    if (error.response.status === 403) {
      localforage.removeItem('token').then(() => {
        router.push({ name: 'auth.index', query: { expired: true } })
      })
    }
    var response = error.response.data
    if (response.message === 'Token has expired') {
      localforage.removeItem('token').then(() => {
        router.push({ name: 'auth.index', query: { expired: true } })
      })
    }
    message = `${response.message}<br />`
    if (response.errors != null && typeof response.errors === 'object') {
      for (var m in response.errors) {
        message += `${response.errors[m]}<br />`
      }
    }
  }

  bus.$emit('sweet-erro', {
    message
  })
  setLoading(false)
  return Promise.reject(error)
}

http.interceptors.request.use(interceptRequest, interceptRequestError)
http.interceptors.response.use(interceptResponse, interceptResponseError)

export default http



// WEBPACK FOOTER //
// ./src/service/http.js